import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import './additionalInfo.css'
import axiosInstance from '../../util/axios'
import { API_ROUTES, FULL_API_ROUTES } from '../../util/constants'

function AdditionalInfo({ selectedArtwork }) {
	const entityType = 'artwork'
	const entityId = selectedArtwork ? selectedArtwork.id : null
	const artworkIds = useSelector((state) => state.entityIds.artwork) ?? []

	const [katalog_photo_link, set_katalog_photo_link] = useState('')
	const [katalog_photo_src, set_katalog_photo_src] = useState('')
	const picasaSubtitle = (selectedArtwork?.additional_info || '')
		.replace(/^aus picasa:/i, '')
		.trim()
	const artworkNumber = artworkIds.indexOf(entityId) + 1

	useEffect(() => {
		set_katalog_photo_link('')
		set_katalog_photo_src('')
		axiosInstance
			.get(API_ROUTES.FILE_LIST(entityType, entityId))
			.then((result) => {
				for (const e of result) {
					try {
						const description = JSON.parse(e.description)
						const location = Number.parseInt(description.location)
						if (location == 1) {
							set_katalog_photo_link(
								FULL_API_ROUTES.FILE_DOWNLOAD(e.file, true)
							)
							set_katalog_photo_src(FULL_API_ROUTES.FILE_DOWNLOAD(e.file))
							break
						}
					} catch (e) {
						console.error(e)
					}
				}
			})
	}, [selectedArtwork])
	return (
		<div id='additionalInformation'>
			<div id='info_title'>
				<div>
					{selectedArtwork.title_description} [{artworkNumber}]
				</div>
			</div>

			<a
				href={katalog_photo_link}
				id='katalog_photo_link'
				target='_blank'
				rel='noreferrer'
			>
				{katalog_photo_src && (
					<div id='katalog_photo_container'>
						<img src={katalog_photo_src} id={'katalog_photo'} />
					</div>
				)}
			</a>

			{picasaSubtitle && (
				<div id='infoField' style={{ marginTop: '20px' }}>
					Bilduntertitel aus Picasa: <br></br>
					{picasaSubtitle}
				</div>
			)}
		</div>
	)
}

export default AdditionalInfo
